export default __webpack_public_path__ + "static/media/Meeting room 1.bbd30c4d.jpg";